export { default as ProfileMessagePage}  from "./profile-message-page.vue"
